import React, { Fragment, useState } from "react";
import styled from "styled-components";
import _forEach from "lodash/forEach";

import { Input } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import { getFontFamily } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { callToActionCss } from "components/CallToAction";

import { formPropTypes } from "./prop-types";
import { Title, StyledP2 } from "../styles";

const UploadWrapper = styled.div`
  text-align: center;
`;

const UploadLabel = styled.label`
  ${callToActionCss}
  ${getFontFamily("regular")}
`;

const Files = styled.div`
  margin-top: 1rem;
  max-height: 200px;
  overflow: auto;
`;
const Filename = styled(StyledP2)`
  margin: 0.25em;
`;

export const DocumentsForm = ({ base }) => {
  const [files, setFiles] = useState([]);
  const handleChange = e => {
    const fileNames = [];

    _forEach(e.target.files, file => {
      fileNames.push(file.name);
    });

    setFiles(fileNames);
  };

  return (
    <Fragment>
      <Title>Documents</Title>
      <div>
        <StyledP2>
          For new construction, please provide electrical schematics/load
          schedules. For retrofits or renovation, please provide one year of
          electric bills and electrical schematics/load schedules.
        </StyledP2>
      </div>
      <UploadWrapper>
        <UploadLabel>
          <Input
            className="hideAccessible"
            multiple
            name={base("Files")}
            onChange={handleChange}
            type="file"
          />
          Upload
        </UploadLabel>
      </UploadWrapper>
      <Files>
        {files.map(name => (
          <Filename key={name}>{name}</Filename>
        ))}
      </Files>
    </Fragment>
  );
};

DocumentsForm.propTypes = formPropTypes;
